export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "repairs",
      layout: "dashboard",
    },
    path: "/repairs",
    name: "repairs",
    component: () => import("@/layouts/index/RepairIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste de ventes",
          layout: "dashboard",
        },
        path: "index",
        name: "repairs-index",
        component: () => import("@/views/repairs/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un vente",
          layout: "dashboard",
        },
        path: "create",
        name: "repairs-create",
        component: () => import("@/views/repairs/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier la vente",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "repairs-edit",
        component: () => import("@/views/repairs/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "L'ajout des articles à un vente",
          layout: "dashboard",
        },
        path: "items/create",
        name: "repairs-items-create",
        component: () => import("@/views/repairs/items/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier les articles d'un vente",
          layout: "dashboard",
        },
        path: ":reference/items/edit",
        name: "repairs-items-edit",
        component: () => import("@/views/repairs/items/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Valider la vente",
          layout: "dashboard",
        },
        path: ":reference/validated",
        name: "repairs-validated",
        component: () => import("@/views/repairs/Validated.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails sur la facturation.",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "repairs-details",
        component: () => import("@/views/repairs/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Ventes (factures) remarquées",
          layout: "dashboard",
        },
        path: "noticed/index",
        name: "repairs-noticed-index",
        component: () => import("@/views/repairs/Noticed.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Ventes à valider",
          layout: "dashboard",
        },
        path: "tovalidate/index",
        name: "repairs-tovalidate-index",
        component: () => import("@/views/repairs/ToValidate.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Rapport client",
          layout: "dashboard",
        },
        path: "customer/report",
        name: "repairs-customer-report",
        component: () => import("@/views/repairs/CustomerReport.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Archive Rapport client",
          layout: "dashboard",
        },
        path: "customer/report/archive",
        name: "repairs-customer-report-archive",
        component: () => import("@/views/repairs/ArchiveCustomerReport.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Statistiques",
          layout: "dashboard",
        },
        path: "statistics/report",
        name: "repairs-statistics-report",
        component: () => import("@/views/repairs/Statistics.vue"),
      },
    ],
  },
];
